import { render, staticRenderFns } from "./FaqTopics.vue?vue&type=template&id=2d3b0032&name=faq"
import script from "./FaqTopics.vue?vue&type=script&lang=js"
export * from "./FaqTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports